import request from '@/utils/request';


/**
 * 获取用户当前治疗方案
 */
export const getCurrentId = (code) => {
    return request.post(`/app-api/api/treatment/${code}/current`);
};

/**
 * 治疗百分比
 */
export const treatmentProgress = (id) => {
    return request.get(`/app-api/app/treatment/statistics/progress-percentage/${id}`);
};

/**
 * 治疗日历
 */
export const treatmentCalendar = (id) => {
    return request.get(`/app-api/app/treatment/statistics/data/${id}`);
};